<template>
  <div class="empty">
    <!-- eslint-disable-next-line -->
    <img src="@/assets/empty.png" alt="" />
    <p>{{ emptyText }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  text: {
    type: String,
    default: () => { return '暂时没有内容' }
  }
})

const emptyText = computed(() => {
  return props.text
})

</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 400px;
  height: 400px;
  margin: 0 auto;
  color: #999;
}
</style>
